exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pageContentWrapper__src-pages-GlobalSettingsAudience-styles__1Vo_9 {\n    padding-bottom: 100px;\n}", "", {"version":3,"sources":["/home/ubuntu/custom_apps_instances/worker/temp/relevant-yield/relevant-frontend/src/pages/GlobalSettingsAudience/styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;CACzB","file":"styles.css","sourcesContent":[".pageContentWrapper {\n    padding-bottom: 100px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"pageContentWrapper": "pageContentWrapper__src-pages-GlobalSettingsAudience-styles__1Vo_9"
};